import styled, { keyframes } from "styled-components";
import Dollar from "./Dollar";

const DollarImage = (props) => (
  <div {...props}>
    <Dollar />
  </div>
);

const aShuffle = keyframes`
  0% {
    transform: translateY(0);
  }
  30%, 100% {
    transform: translateY(6px);
  }
`;

const aFadeOut = keyframes`
  0% {
    opacity: 1;
  }
  30%, 100% {
    opacity: 0;
  }
`;

const aFadeIn = keyframes`
  0% {
    opacity: 0;
  }
  10%, 100% {
    opacity: 1;
  }
`;

const aSlideIn = keyframes`
  0% {
    transform: translateX(-50%);
  }
  30%, 100% {
    transform: translateX(0);
  }
`;

const Wrapper = styled.div`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    display: block;
    width: 100%;
  }
`;

const StackedDollar = styled(DollarImage)`
  position: absolute;
  top: 0;
  left: 0;

  width: 100%;
  overflow: hidden;

  background: ${(props) => props.theme.colors.background};
  border-radius: 4px;
  filter: drop-shadow(0 1px rgba(0, 0, 0, 0.1));

  transition: all 0.15s;
  will-change: transform, opacity;

  ${() => {
    return new Array(5).fill(null).map((_, i) => {
      return `
        &:nth-child(${i + 1}) {
          transform: translateY(${-(i * 6)}px);

          svg {
            opacity: ${0.2 + i * 0.2};
          }
        }
      `;
    });
  }}

  &:first-child {
    animation: ${aFadeOut} 1.2s infinite cubic-bezier(0.65, 0, 0.35, 1);
  }
`;

const NewDollar = styled(DollarImage)`
  position: absolute;
  top: -30px;
  left: 0;

  width: 100%;

  filter: drop-shadow(0 1px rgba(0, 0, 0, 0.1));

  animation: ${aFadeIn} 1.2s infinite cubic-bezier(0.65, 0, 0.35, 1),
    ${aSlideIn} 1.2s infinite cubic-bezier(0.65, 0, 0.35, 1);
`;

const Stack = styled.div`
  position: relative;

  width: 64px;

  animation: ${aShuffle} 1.2s infinite cubic-bezier(0.65, 0, 0.35, 1);
`;

const DollarStackAnimation = () => {
  return (
    <Wrapper>
      <Stack>
        <StackedDollar />
        <StackedDollar />
        <StackedDollar />
        <StackedDollar />
        <StackedDollar />

        <NewDollar />
      </Stack>
    </Wrapper>
  );
};

export default DollarStackAnimation;
